export const FAQ_ITEMS = [
  {
    question: "What products does RKG NATURALS supply?",
    answer:
      "RKG NATURALS supplies agricultural, food and natural products including fresh fruits, vegetables, grains, pulses, spices, herbs and natural products.",
    testId: "faq-item-1",
  },
  {
    question: "Where is RKG NATURALS based?",
    answer: "RKG NATURALS operates from Maharashtra, India.",
    testId: "faq-item-2",
  },
  {
    question: "Does RKG NATURALS export internationally?",
    answer: "Yes. RKG NATURALS provides export-related sourcing and supply services for international buyers.",
    testId: "faq-item-3",
  },
  {
    question: "Do you handle wholesale orders?",
    answer: "Yes. We handle wholesale and bulk requirements according to product availability and buyer requirements.",
    testId: "faq-item-4",
  },
  {
    question: "Do you accept bulk export orders?",
    answer:
      "Yes. RKG NATURALS accepts bulk enquiries for selected products, subject to availability, specifications and buyer requirements.",
    testId: "faq-item-5",
  },
  {
    question: "Can I request specific product specifications?",
    answer: "Yes. Buyers can share their required product, quantity, grade, packaging and destination details.",
    testId: "faq-item-6",
  },
  {
    question: "How can I request a quotation?",
    answer:
      "You can submit your requirements through the Request a Quote form or contact RKG NATURALS directly by phone, WhatsApp or email.",
    testId: "faq-item-7",
  },
  {
    question: "Do you provide customized packaging?",
    answer: "Customized packaging can be discussed according to the product and buyer requirements.",
    testId: "faq-item-8",
  },
  {
    question: "How can I contact RKG NATURALS?",
    answer: "You can contact us by phone/WhatsApp or email. Our business operates 24/7.",
    testId: "faq-item-9",
  },
];
